module.exports = __webpack_public_path__ + "media/images/pc/top/recommend_plan_anchor_arrow-ff6a730a7c0138057b2d2516ac357a4c.svg";